const DEFAULT_PORTAL_STACK = 'Inter, sans-serif';

export const PORTAL_FONTS = new Map<string, string>([
  ['Alumni Sans', "'Alumni Sans', sans-serif"],
  ['Bebas Neue', "'Bebas Neue', Impact, sans-serif"],
  ['Caveat', 'Caveat, cursive'],
  ['Dancing Script', "'Dancing Script', cursive"],
  ['Fjalla One', "'Fjalla One', Impact, sans-serif"],
  ['Lato', 'Lato, sans-serif'],
  ['Newsreader', 'Newsreader, Georgia, serif'],
  ['Open Sans', "'Open Sans', sans-serif"],
  ['Playfair Display', "'Playfair Display', Georgia, serif"],
  ['Plus Jakarta Sans', "'Plus Jakarta Sans', sans-serif"],
  ['Roboto', 'Roboto, sans-serif'],
  ['Tangerine', 'Tangerine, cursive'],
]);

const NON_DECORATIVE_FONT_FAMILIES = new Set([
  'Alumni Sans',
  'Lato',
  'Newsreader',
  'Open Sans',
  'Playfair Display',
  'Plus Jakarta Sans',
  'Roboto',
]);

export const NON_DECORATIVE_FONTS = new Map(
  [...PORTAL_FONTS].filter(([fontFamily]) =>
    NON_DECORATIVE_FONT_FAMILIES.has(fontFamily),
  ),
);

export function isPortalFontFamily(value: unknown): value is string {
  return typeof value === 'string' && PORTAL_FONTS.has(value);
}

export function resolvePortalFontStack(
  fontFamily: string | null | undefined,
): string {
  return (fontFamily && PORTAL_FONTS.get(fontFamily)) || DEFAULT_PORTAL_STACK;
}
